interface ChatBubbleSolidIconProps {
  color?: string;
  size?: string;
  className?: string;
}

export const ChatBubbleSolidIcon = ({
  color = 'currentColor',
  size = '12',
  className,
  ...props
}: ChatBubbleSolidIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.00014 1.125C4.78556 1.125 3.59151 1.21386 2.42418 1.3855C1.43502 1.53094 0.75 2.39727 0.75 3.37032V6.37967C0.75 7.35272 1.43502 8.21905 2.42418 8.36449C2.86246 8.42893 3.30451 8.48171 3.75 8.52249V10.5C3.75 10.6517 3.84137 10.7884 3.98149 10.8465C4.12162 10.9045 4.28292 10.8724 4.39016 10.7652L6.48191 8.67342C6.51591 8.63942 6.5633 8.61868 6.61509 8.61739C7.61807 8.59255 8.60615 8.50711 9.57579 8.36455C10.565 8.21912 11.25 7.35278 11.25 6.37973V3.37028C11.25 2.39722 10.565 1.53088 9.57579 1.38546C8.40856 1.21385 7.21461 1.125 6.00014 1.125ZM4.125 4.3125C3.81434 4.3125 3.5625 4.56434 3.5625 4.875C3.5625 5.18566 3.81434 5.4375 4.125 5.4375C4.43566 5.4375 4.6875 5.18566 4.6875 4.875C4.6875 4.56434 4.43566 4.3125 4.125 4.3125ZM5.4375 4.875C5.4375 4.56434 5.68934 4.3125 6 4.3125C6.31066 4.3125 6.5625 4.56434 6.5625 4.875C6.5625 5.18566 6.31066 5.4375 6 5.4375C5.68934 5.4375 5.4375 5.18566 5.4375 4.875ZM7.875 4.3125C7.56434 4.3125 7.3125 4.56434 7.3125 4.875C7.3125 5.18566 7.56434 5.4375 7.875 5.4375C8.18566 5.4375 8.4375 5.18566 8.4375 4.875C8.4375 4.56434 8.18566 4.3125 7.875 4.3125Z"
      fill={color}
    />
  </svg>
);
